import "twin.macro";

import { useFormContext, useWatch } from "react-hook-form";
import { Link } from "react-router";

import { Button } from "@mui/material";

import { BlockCard, Type } from "@features/ui";
import { BlockCardActions } from "@features/ui/BlockCard";
import { User } from "@models/User";
import useRoleIs from "@utils/useRoleIs";

const UserFormDistributor = ({ user }: { user: User }) => {
  const roleIs = useRoleIs();
  const { setValue } = useFormContext();
  const distributorId = useWatch({ name: "distributorId" });
  function handleToggleDistributor() {
    setValue("distributorId", distributorId ? null : user.distributorId, {
      shouldDirty: true,
    });
  }
  return (
    <BlockCard title="Distributor">
      <Type.P>
        This user is part of <strong>{user.distributorName}</strong>. Go to the
        distributor page to manage this user's access.
      </Type.P>
      <BlockCardActions tw="mt-4">
        {roleIs("super") && (
          <Button variant="outlined" onClick={handleToggleDistributor}>
            {distributorId ? "Remove From Distributor" : "Undo"}
          </Button>
        )}
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to={`/admin/distributors/${user.distributorId}`}
        >
          Manage Distributor
        </Button>
      </BlockCardActions>
    </BlockCard>
  );
};

export default UserFormDistributor;
